import React from 'react';
import styled, { css } from 'styled-components';
import { PageSection, SectionBody } from './PageSection';
import RichText from './RichText';
import PropTypes from 'prop-types';
import { Heading, Box } from 'grommet';
import { DecoratedImage } from './DecoratedImage';
import { GatsbyImage, getImageData } from 'gatsby-plugin-image';

const LeftOrientation = css`
  grid-template-areas: 'content image';
  grid-template-columns: 1fr calc(6 / 12 * 100%);
`;
const RightOrientation = css`
  grid-template-areas: 'image content';
  grid-template-columns: calc(4 / 12 * 100%) 1fr;
`;

const BodyGrid = styled.div`
  display: grid;
  grid-gap: calc(var(--gutters) * 4);
  grid-template-areas: 'image' 'content';
  align-items: start;

  > div:nth-of-type(1) {
    grid-area: content;
  }
  > div:nth-of-type(2) {
    grid-area: image;
  }

  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    ${({ $orientation }) => {
      // console.log('orientation', $orientation);
      switch ($orientation) {
        case 'left':
          return LeftOrientation;
        case 'right':
        default:
          return RightOrientation;
      }
    }}
  }
`;

const ShortSection = ({ title, body, image, orientation, ...rest }) => {
  const hasTitle = title !== null;
  return (
    <PageSection {...rest}>
      <SectionBody>
        <BodyGrid $orientation={orientation}>
          <Box>
            {hasTitle ? (
              <Box pad={{ bottom: '1rem' }}>
                <Heading level="2">{title}</Heading>
              </Box>
            ) : null }
            <RichText richText={body} />
          </Box>
          <Box>
            <DecoratedImage>
              <GatsbyImage image={image.gatsbyImageData} />
            </DecoratedImage>
          </Box>
        </BodyGrid>
      </SectionBody>
    </PageSection>
  );
};

export default ShortSection;
